import { render, staticRenderFns } from "./person-data.vue?vue&type=template&id=67d6eb0c&scoped=true&"
import script from "./person-data.vue?vue&type=script&lang=js&"
export * from "./person-data.vue?vue&type=script&lang=js&"
import style0 from "./person-data.vue?vue&type=style&index=0&id=67d6eb0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6eb0c",
  null
  
)

export default component.exports